import { useMemo } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { Navigate, Route, Routes } from 'react-router-dom'

import AuthProvider from './auth/AuthProvider'
import RequireAuth from './auth/RequireAuth'
import { useAuth } from './auth/authContext'
import { useColorMode } from './hooks/useColorMode'
import { createAppTheme } from './theme/appTheme'
import LoginPage from './pages/LoginPage'
import TallyPingMonitor from './pages/TallyPingMonitor'

// Signed-in people have no business on the login page; send them on.
function LoginRoute({ mode, onToggleMode }) {
  const { session } = useAuth()
  if (session) return <Navigate to="/dashboard" replace />
  return <LoginPage isDark={mode === 'dark'} onToggleMode={onToggleMode} />
}

function DashboardRoute({ mode, onToggleMode }) {
  const { session, logout } = useAuth()
  return <TallyPingMonitor mode={mode} onToggleMode={onToggleMode} user={session?.user} onLogout={logout} />
}

export default function App() {
  const [mode, toggleMode] = useColorMode('light')
  const theme = useMemo(() => createAppTheme(mode), [mode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginRoute mode={mode} onToggleMode={toggleMode} />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <DashboardRoute mode={mode} onToggleMode={toggleMode} />
              </RequireAuth>
            }
          />
          {/* Anything else — including "/" — goes to the dashboard, which in turn
              sends you to /login if you are not signed in. */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  )
}
